export default "__VITE_PUBLIC_ASSET__8ceb3737__"